import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonModule } from '@angular/common';
import { SharedLavorazioniModule } from '../../main-home/pages/lavorazioni/modules/shared-lavorazioni/shared-lavorazioni.module';
import { InViewportDirective } from '../../../directives/in-viewport.directive';
import { BackButtonComponent } from '../../../components/back-button/back-button.component';

@Component({
    selector: 'app-reset-password',
    imports: [ReactiveFormsModule,
        CommonModule, SharedLavorazioniModule, InViewportDirective, BackButtonComponent],
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnInit {
  toggled1: boolean = true;
  toggled2: boolean = true;
  type1: string = 'password';
  type2: string = 'password';
  validPassword: boolean = true;
  equalPassword: boolean = true;
  errorMessage: boolean = false;


  token = '';
  email = '';
  resetPwdForm = new FormGroup({
    new_password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    confirm_password: new FormControl('', [Validators.required, Validators.minLength(6)]),
  }, {
    validators: this.mustMatch('new_password', 'confirm_password')
  });
  constructor(private route: ActivatedRoute, private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.params
      .subscribe(
        (params: Params) => {
          // console.log('params:', params['token']);
          this.token = params['token'];
        });

    this.route.queryParams
      .subscribe(
        (params: Params) => {
          if (params['email']) {
            // console.log('params:', params['email']);
            this.email = params['email'];
          }
        });
  }

  private mustMatch(firstControl: string, secondControl: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.get(firstControl)?.value;
      const confirm = control.get(secondControl)?.value;
      if (password != confirm) { return { 'noMatch': true } }
      return null
    }
  }

  resetPassword() {
    let new_pass = this.resetPwdForm.get('new_password')?.value;
    let confirm_pass = this.resetPwdForm.get('confirm_password')?.value;
    if (this.resetPwdForm.valid && new_pass && confirm_pass && this.equalPassword && this.validPassword) {
      this.authenticationService.resetPasswordServer(this.token, this.email,
        new_pass, confirm_pass);
    }
  }
  seePassword(id: string) {
    if (id === 'confirm_password') {
      if (this.type2 === 'password') {
        this.type2 = 'text';
        this.toggled2 = false;
      }
      else {
        this.type2 = 'password';
        this.toggled2 = true;
      }
    }
    else {
      if (this.type1 === 'password') {
        this.type1 = 'text';
        this.toggled1 = false;
      }
      else {
        this.type1 = 'password';
        this.toggled1 = true;
      }
    }
  }
  goLogin() {
    this.router.navigate(['login']);
  }
  checkPsw() {
    const password = this.resetPwdForm.get('new_password')?.value;
    const passwordRepeat = this.resetPwdForm.get('confirm_password')?.value;
    const regex = /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":|<>])(?=.{8,})/;
    if (regex.test(password!)) {
      if (password === passwordRepeat) {
        this.equalPassword = true;
        this.validPassword = true;
        this.errorMessage = false;
      }
      else {
        this.equalPassword = false;
        this.validPassword = true;
        this.errorMessage = true;
      }
    }
    else {
      this.equalPassword = true;
      this.validPassword = false;
      this.errorMessage = true;
    }
  }
}
